<template lang="">
    <div class='fixed z-50 top-0 left-0 w-screen h-screen  text-1xl pointer-events-none'>

        <div class='flex items-center justify-center h-full mt-72 '>
    <div v-if='store.active === true && store.type === true' class='bg-green-400 p-2 flex flex-row gap-3 pointer-events-auto'>
        {{console.log("asddasa")}}
        {{store.message}}
        <div @click='closeMessage' > <v-icon class="icon flex justify-start hover:cursor-pointer self-end" scale="1" name="io-close" /></div>
        
    </div>
    <div v-if='store.active === true && store.type === false' class='bg-red-400 p-2 flex flex-row gap-3 pointer-events-auto'>
        {{store.message}}
        <div @click='closeMessage' > <v-icon class="icon flex justify-start hover:cursor-pointer" scale="1" name="io-close" /></div>

    </div>
</div>
</div>
</template>
<script setup>

import {MessageStore} from '@/stores/Messages'

const store = MessageStore();
  
function closeMessage(){
    store.inactivateMessage();
}
</script>
<style lang="">
    
</style>